"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.changePasswordValidationRules = void 0;
// Validation rules: https://angieslist.atlassian.net/wiki/display/SE/Data+Validation

var changePasswordValidationRules = exports.changePasswordValidationRules = {
  oldPassword: {
    required: true
  },
  newPassword: {
    required: true,
    password: true,
    notEqualTo: 'oldPassword',
    msg: 'New password needs to meet the requirements'
  },
  newPasswordConfirmation: {
    required: true,
    equalTo: 'newPassword'
  }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/account-ion/lib/modules/common/browser/validations/changePassword.js
// module id = 4250
// module chunks = 9